<template lang="pug">
  .bg-gray-100.p-2.min-h-screen
    h3.font-bold.mb-3.text-gray-700.text-center 
      span(v-if="!_id") Nuevo 
      span(v-if="copiando") Copiando 
      span Gasto
      div(v-if="_id")
        span.text-xxs.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Creado {{ fechaCreacion | fromNow }}
      div(v-if="copiando")
        span.text-xxs.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Copiando cirugía, haga los cambios necesarios y presione guardar


    transition-group.contenedor-transition-box(name="fade-smooth-two", tag="div")

      .flex.mb-2(key="fecha")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Fecha
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="date"
            v-model='fecha'
          )

      .flex.mb-2(key="tipo-gasto")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Tipo gasto
          .relative
            input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
              v-model='descripcionTipoGasto'
              @keyup.down="showPopoverTipoGasto = true"
              @keyup.up="showPopoverTipoGasto = true"
              @keyup.space="showPopoverTipoGasto = true"
              @click="showPopoverTipoGasto = true"
              ref="tipoGasto"
              placeholder="No se han ingresado datos"
            )
            span.absolute.left-0.top-0.pt-2.pl-3
              i.fas.fa-funnel-dollar.text-gray-500
            
            span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverTipoGasto = true")
              i.fas.fa-angle-down.text-gray-500
            transition(name="slide-up")
              u-popover(v-if="showPopoverTipoGasto", @close="showPopoverTipoGasto = false")
                tipo-gasto-seleccionar(
                  @selected="seleccionarTipoGasto"
                  @close="cerrarTipoGasto"
                )

      .flex.mb-2(key="empleado")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Empleado
          .relative
            input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
              v-model='nombreEmpleado'
              @keyup.down="showPopoverEmpleado = true"
              @keyup.up="showPopoverEmpleado = true"
              @keyup.space="showPopoverEmpleado = true"
              @click="showPopoverEmpleado = true"
              ref="empleado"
              placeholder="No se han ingresado datos"
              :disabled="perfil === 'tecnico' || perfil === 'enfermera'"
            )
            span.absolute.left-0.top-0.pt-2.pl-3
              i.fas.fa-user.text-gray-500
            
            span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverEmpleado = true", v-if="perfil !== 'tecnico' && perfil !== 'enfermera'")
              i.fas.fa-angle-down.text-gray-500
            transition(name="slide-up")
              u-popover(v-if="showPopoverEmpleado", @close="showPopoverEmpleado = false")
                empleado-seleccionar(
                  @selected="seleccionarEmpleado"
                  @close="cerrarEmpleado"
                )

      .flex.mb-2(key="moneda")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Moneda
          
          .flex
            .flex.flex-col.flex-1.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out.cursor-pointer(
              @click="moneda = 'soles'"
              :class="{'is-active': moneda === 'soles'}"
            )

              .text-gray-500 S/
              span Soles
            .flex.flex-col.flex-1.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out.cursor-pointer(
              @click="moneda = 'dolares'"
              :class="{'is-active': moneda === 'dolares'}"
            )
              .text-gray-500 $
              span Dólares

      
      .flex.mb-2(key="monto")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Monto
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="number"
            v-model='monto'
          )

      .flex.mb-2(key="comentario")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Comentario
          
          textarea.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            v-model='comentario'
          )

      div.mb-3(v-if="copiando", key="copy-message")
        span.text-xxs.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Copiando cirugía, haga los cambios necesarios y presione guardar
      
      .flex.mb-2.justify-center.mb-20(key="acciones")
        .bg-primary.text-sm.flex.items-center.text-white.py-2.px-4.rounded.cursor-pointer(@click="save") Guardar
        .text-primary.text-sm.flex.items-center.border-primary.border.py-2.px-4.rounded.ml-2.cursor-pointer(@click="irANuevoGasto", v-if="_id") Nuevo gasto
        .bg-primary.text-sm.flex.items-center.text-white.py-2.px-4.rounded.ml-2.cursor-pointer(v-if="_id && copiando === false", @click="copy") Duplicar
        .bg-red-500.text-sm.flex.items-center.text-white.py-2.px-4.rounded.ml-2.cursor-pointer(v-if="perfil === 'administrador' && _id && !copiando", @click="remove") Eliminar
</template>

<script>
import Popover from '@/components/c_util_popover.vue'
import EmpleadoSeleccionar from '@/components/c_empleado_seleccionar.vue'
import TipoGastoSeleccionar from '@/components/c_tipo_gasto_seleccionar.vue'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import Router from '../router/admin.js'
export default {
  name: 'v_gasto_form',
  props: ['_id'],
  components: {
    'u-popover'              : Popover,
    'empleado-seleccionar'   : EmpleadoSeleccionar,
    'tipo-gasto-seleccionar' : TipoGastoSeleccionar
  },
  data () {
    return {
      perfil                : localStorage.getItem('perfil'),
      nombreUsuarioLogueado : localStorage.getItem('nombre'),
      idLogueado            : localStorage.getItem('_id'),
      isLoading             : false,
      // input empleado
      showPopoverEmpleado   : false,
      idEmpleado            : '',
      nombreEmpleado        : '',
      // input tipo gasto
      showPopoverTipoGasto  : false,
      idTipoGasto           : '',
      descripcionTipoGasto  : '',
      //
      comentario            : '',
      moneda                : '',
      monto                 : 0,
      fecha                 : '',
      fechaCreacion         : '',
      copiando               : false
    }
  },
  mounted () {
    var vm = this
    if (vm._id) {
      // Si tiene un id, debemos cargar
      vm.fetch()
    } else {
      vm.fecha = window.moment().format('YYYY-MM-DD')

      if (vm.perfil === 'tecnico' || vm.perfil === 'enfermera') {
        vm.idEmpleado     = vm.idLogueado
        vm.nombreEmpleado = vm.nombreUsuarioLogueado
      }
    }
  },
  methods: {
    // Popover empleado
    seleccionarEmpleado (o) {
      var vm            = this
      vm.idEmpleado           = o._id + ''
      vm.nombreEmpleado       = o.nombre
      vm.showPopoverEmpleado  = false
      vm.$refs.empleado.focus()
    },
    cerrarEmpleado (o) {
      var vm            = this
      vm.showPopoverEmpleado = false
      vm.$refs.empleado.focus()
    },
    //* Popover empleado
    // Popover Tipo Gasto
    seleccionarTipoGasto (o) {
      var vm            = this
      vm.idTipoGasto           = o._id + ''
      vm.descripcionTipoGasto       = o.descripcion
      vm.showPopoverTipoGasto  = false
      vm.$refs.tipoGasto.focus()
    },
    cerrarTipoGasto (o) {
      var vm            = this
      vm.showPopoverTipoGasto = false
      vm.$refs.tipoGasto.focus()
    },
    //* Popover TipoGasto
    save () {
      var vm = this
      if (!vm.idEmpleado) {
        notify(vm, 'error', 'Error', 'Debe ingresar un empleado')
        return
      }
      if (!vm.monto) {
        notify(vm, 'error', 'Error', 'Debe ingresar un monto')
        return
      }
      if (!vm.idTipoGasto) {
        notify(vm, 'error', 'Error', 'Debe ingresar un tipo de cirugía')
        return
      }

      if (vm.copiando) vm._id = ''

      // vm.isLoading = true
      var obj = {
        _id                  : vm._id,
        fecha                : vm.fecha,
        idTipoGasto          : vm.idTipoGasto,
        descripcionTipoGasto : vm.descripcionTipoGasto,
        idEmpleado           : vm.idEmpleado,
        nombreEmpleado       : vm.nombreEmpleado,
        moneda               : vm.moneda,
        monto                : vm.monto,
        comentario           : vm.comentario
      }

      apiPost(vm, '/gasto', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')

        var _id = vm._id
        if (!vm._id) _id = data.insertedId

        Router.push('/gasto/' + _id)
        vm.$router.go()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    fetch () {
      var vm = this
      vm.isLoading  = true
      var url       = '/gasto/' + vm._id
      var obj = {
        _id : vm._id
      }
      apiGet(vm, url, obj, function (data) {
        vm.fecha                = data.documento.fecha
        vm.idTipoGasto          = data.documento.idTipoGasto
        vm.descripcionTipoGasto = data.documento.descripcionTipoGasto
        vm.idEmpleado           = data.documento.idEmpleado
        vm.nombreEmpleado       = data.documento.nombreEmpleado
        vm.moneda               = data.documento.moneda
        vm.monto                = data.documento.monto
        vm.comentario           = data.documento.comentario
        vm.fechaCreacion        = data.documento.fechaCreacion
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        Router.push('/gasto')
      }, function () {
        vm.isLoading  = false
      })
    },
    irANuevoGasto () {
      var vm = this
      Router.push('/gasto')
      vm.$router.go()
    },
    copy () {
      var vm = this
      vm.copiando = true
    },
    remove () {
      var vm = this

      var confirmed = window.confirm('¿Desea eliminar este gasto?')

      if (confirmed) {
        var obj = {
          _id                    : vm._id
        }
        apiDelete(vm, '/gasto', obj, function (data) {
          notify(vm, 'success', 'Éxito', 'Eliminado correctamente')
          Router.push('/gastos/')
          vm.$router.go()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .is-active
    color #2e7bda
    i
      color #2e7bda
    border-color #2e7bda
    
</style>



// WEBPACK FOOTER //
// v_gasto_form.vue?d729da1c